class PrintPage extends HTMLElement {
  constructor() {
    super();
    this.initializePrint();
  }

  /**
   * Initialize the print functionality with proper state handling
   */
  initializePrint() {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      // Document already loaded, trigger print immediately
      this.triggerPrint();
    } else {
      // Wait for document to be ready before printing
      document.addEventListener('DOMContentLoaded', () => this.triggerPrint());
    }
  }

  /**
   * Trigger the print dialog after all images are loaded
   */
  triggerPrint() {
    try {
      // Wait for all images to load before printing
      const images = this.querySelectorAll('img');
      const imagePromises = Array.from(images).map((img) => {
        if (img.complete) return Promise.resolve();
        return new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve; // Resolve even on error to not block printing
        });
      });

      Promise.all(imagePromises).then(() => {
        window.print();
      });
    } catch (error) {
      console.error('Failed to print page:', error);
    }
  }
}

if (!customElements.get('print-page')) {
  customElements.define('print-page', PrintPage);
}
